import React from 'react';
import { withAuthenticationRequired } from '../providers/withAuthenticationRequired';
import { PaymentProcessingPage } from '../Components/PaymentProcessing';

function PaymentPage() {
  return <PaymentProcessingPage />;
}

export default withAuthenticationRequired(PaymentPage);
